import React, { Component } from 'react';
import Chart from 'chart.js';
import Skeleton from 'react-loading-skeleton';
import { DS_CHART_TOKENS, chartDownloadFileName, getCanvasChartColor } from '../../../utils/chartTheme';
import { DownloadPngButton } from '../pngExport';

class DoughnutGraphHRA extends Component {
  nodeRef = React.createRef();

  shouldComponentUpdate(nextProps, _) {
    return !(
      nextProps.hraCompleted === this.props.hraCompleted && nextProps.totalCustomers === this.props.totalCustomers
    );
  }

  componentDidUpdate() {
    if (this.props.loading) return;
    const { graphData } = this.props;
    var ctx = document.getElementById('myChart').getContext('2d');

    new Chart(ctx, {
      type: 'doughnut',
      data: {
        datasets: [
          {
            data: graphData.map((item) => item.percentage),
            backgroundColor: graphData.map((item) => getCanvasChartColor(item.color)),
            borderColor: getCanvasChartColor(DS_CHART_TOKENS.paper),
            borderWidth: 2,
          },
        ],
      },
      options: {
        tooltips: {
          enabled: false,
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
          },
        },
        responsive: true,
        legend: {
          display: false,
          position: 'top',
        },
        title: {
          display: false,
          text: ('Health Risk Assessment' || 'Spending Account'),
        },
        cutoutPercentage: 68,
        animation: {
          duration: 700,
          easing: 'easeOutQuart',
        },
      },
    });
  }

  getTotalCount() {
    const { graphData } = this.props;
    if (graphData.length > 0) {
      return graphData[0].percentage;
    }
    return 0;
  }

  render() {
    if (this.props.loading) {
      return <Skeleton width='100%' height={this.props.loaderHeight} />;
    }
    const { hraCompleted, totalCustomers } = this.props;
    return (
      <div ref={this.nodeRef} className={`relative flex flex-row bg-white border border-gray-200 rounded-[14px] p-6 shadow-sm ` + this.props.classes}>
        <div className='absolute right-2 top-2 z-10' data-download-ignore='true'>
          <DownloadPngButton nodeRef={this.nodeRef} fileName={chartDownloadFileName(this.props.title, 'hra-summary')} />
        </div>
        <div className='flex flex-col items-center'>
          <div className='text-2xl text-gray-900 font-semibold mt-20 absolute font-jetbrains-mono tabular-nums tracking-tight'>{this.getTotalCount()}%</div>
          <div className='text-gray-500 text-[11px] font-medium mt-28 absolute'>{this.props.circleTitle}</div>
          <div className='myChartDiv'>
            <canvas id='myChart' width='200' height='200'></canvas>
          </div>
        </div>
        <div className={'flex flex-col items-start ml-10'}>
          <p className='text-gray-900 font-semibold mt-12'>{this.props.title}</p>
          <hr width='50px' style={{ borderTop: '2px solid var(--sem-blue-400)' }} />
          <p className='text-gray-700 text-sm mt-4'>
            {this.props.circleTitle === 'HRA completed' ?
            <div>
            <span className='font-semibold'>{hraCompleted}</span> out of {totalCustomers}
            </div>
            :
            <div className='text-gray-600 leading-3'>
              <span className='font-semibold '>{this.getTotalCount()}%({hraCompleted}</span> out of {totalCustomers})
            </div>
            }
          </p>
        </div>
      </div>
    );
  }
}

DoughnutGraphHRA.defaultProps = {
  classes: '',
};

export default DoughnutGraphHRA;
